// Számlázási-profil sor-akciók: a számlázási adatok MÁSOLÁSA (mindenkinek, aki a listát látja — olvasási
// művelet) + jog-vezérelten: elsődlegessé tétel (csillag, billing_profiles.manage — CSAK
// nem-elsődleges soron) + szerkesztés (ceruza, manage) + törlés (kuka, billing_profiles.delete). Az elsődleges
// profil törlését a BFF 409-cel tiltja → a lista toast + rollback jelzi (a UI a kukát nem rejti el, mert az
// „elsődleges" is törölhető LENNE egy másik elsődleges kijelölése után — a szerver a végső fal). Külön
// (tesztelhető) komponens: a jog- és állapot-kombinációk egységben ellenőrizhetők (az invoice-row-actions mintára).
import { ClipboardDocumentIcon, StarIcon } from '@heroicons/react/24/outline';
import { type TFunction } from 'i18next';

import {
  DeleteRowAction,
  EditRowAction,
  RowActionButton,
  RowActions,
} from '@/components/shared/list-row-actions';

export interface BillingProfileRowActionsRow {
  id: string;
  isPrimary: boolean;
}

interface BillingProfileRowActionsProps<T extends BillingProfileRowActionsRow> {
  row: T;
  canManage: boolean;
  canDelete: boolean;
  onEdit: (row: T) => void;
  onSetPrimary: (row: T) => void;
  onDelete: (row: T) => void;
  onCopy: (row: T) => void;
  t: TFunction;
}

export function BillingProfileRowActions<T extends BillingProfileRowActionsRow>({
  row,
  canManage,
  canDelete,
  onEdit,
  onSetPrimary,
  onDelete,
  onCopy,
  t,
}: BillingProfileRowActionsProps<T>): JSX.Element {
  const showSetPrimary = canManage && !row.isPrimary;

  return (
    <RowActions>
      <RowActionButton
        label={t('billingProfiles.copyDetails.action')}
        icon={ClipboardDocumentIcon}
        onClick={() => onCopy(row)}
      />
      {showSetPrimary && (
        <RowActionButton
          label={t('billingProfiles.setPrimary')}
          icon={StarIcon}
          onClick={() => onSetPrimary(row)}
        />
      )}
      {canManage && <EditRowAction label={t('billingProfiles.edit')} onClick={() => onEdit(row)} />}
      {canDelete && (
        <DeleteRowAction label={t('billingProfiles.delete')} onClick={() => onDelete(row)} />
      )}
    </RowActions>
  );
}
